"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProviderArea = void 0;
const Acreage_1 = __importDefault(require("@becrop/components/Modules/Common/Models/Acreage"));
class ProviderArea {
    constructor(obj) {
        this.leafFieldId = obj.leafFieldId || '-';
        this.areaName = obj.areaName || '-';
        this.fieldName = obj.fieldName || '-';
        this.geometry = obj.geometry || '-';
        this.extension = obj.extension || -1;
        this.extension_units = obj.extension_units || '-';
        this.providerName = obj.providerName || '-';
        this.acreage = new Acreage_1.default(obj.extension, obj.extension_units);
    }
}
exports.ProviderArea = ProviderArea;
